// SDK auth locks may ignore AbortSignal. The caller must still fail closed.
export function withinDeadline<T>(pending: PromiseLike<T>, signal?: AbortSignal): Promise<T> {
  const deadline = signal ? AbortSignal.any([signal, AbortSignal.timeout(15_000)]) : AbortSignal.timeout(15_000)
  return new Promise<T>((resolve, reject) => {
    const aborted = () => reject(new Error('Access verification timed out. Retry to continue.'))
    if (deadline.aborted) { aborted(); return }
    deadline.addEventListener('abort', aborted, { once: true })
    Promise.resolve(pending).then(resolve, reject).finally(() => deadline.removeEventListener('abort', aborted))
  })
}
